import { Navigate } from 'react-router-dom';
import authService from '../services/auth.service';

/**
 * ProtectedRoute Component
 * Chỉ cho phép user đã login mới truy cập được
 * Nếu chưa login, redirect về /login
 */
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = authService.isLoggedIn();

  if (!isLoggedIn) {
    // Redirect to login page if not logged in
    return <Navigate to="/login" replace />;
  }

  // Render children if logged in
  return children;
};

export default ProtectedRoute;

